import { useLocation } from 'react-router-dom';

export const useTokenQueryParam = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get('token');
}